
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-history",
  "use": "icon-material-history-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-history\"><path d=\"M476.77-114.02q-151.88 0-257.6-107.16Q113.45-328.33 113.78-481h68.13q.28 124.12 85.53 211.48 85.24 87.37 209.32 87.37 125.81 0 213.33-88.36t87.52-214.45q0-123.08-88.37-207.99-88.38-84.9-212.48-84.9-66.09 0-124.15 29.45-58.07 29.44-101.35 78.29h99.98V-607H137.46v-212.54h62.63v103.37q52.71-60.53 124.45-95.29t152.22-34.76q76.2 0 143.27 28.6 67.08 28.6 117.47 77.94 50.4 49.34 79.32 115.41T845.74-482t-28.92 143.27-79.32 116.91Q687.11-171.98 620.03-143q-67.07 28.98-143.26 28.98M603.8-315.57l-154-152V-683h62.63v189l136.53 133.28z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-history"/>
                </svg>
            );
        };

        Icon.id = "icon-material-history";

        export default Icon;
    